import type { ApolloQueryResult } from "@apollo/client";

export interface SanitizedGraphQLError {
  message: string;
  path?: readonly (string | number)[];
  code?: unknown;
  debugMessage?: unknown;
}

export interface SanitizedGraphQLDebugInfo {
  hasData: boolean;
  hasErrors: boolean;
}

type GQLData = {
  gqlErrors: SanitizedGraphQLError[];
  debug: SanitizedGraphQLDebugInfo;
};

class SentryGraphQLError extends Error {
  public readonly data: GQLData;

  constructor(message: string, response: ApolloQueryResult<unknown>) {
    super(message);

    this.name = "SentryGraphQLError";

    const gqlErrors = (response.errors ?? []).map((e) => ({
      message: e.message.replace(
        /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi,
        "[email]",
      ),
      path: e.path,
      code: e.extensions?.code,
      debugMessage: e.extensions?.debugMessage,
    }));

    this.data = {
      gqlErrors,
      debug: {
        hasData: response.data !== null && response.data !== undefined,
        hasErrors: gqlErrors.length > 0,
      },
    };
  }
}

export default SentryGraphQLError;
